import { Routes } from '@angular/router';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import { CAR_CONFIG } from './base/car-configs';

/**
 * 렌터카 전용 라우팅
 *
 * mrhst 통합 라우팅과 독립적으로 동작.
 * CAR_CONFIG.routePath 경로로 등록.
 */
export const carRoutes: Routes = [
  {
    path: CAR_CONFIG.routePath,
    canActivate: [permissionGuard('CAR_GOODS$READ')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/car-list-page/car-list-page.component'
          ).then((m) => m.CarListPageComponent),
        data: {
          config: CAR_CONFIG,
          title: '렌터카',
        },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/car-detail-page/car-detail-page.component'
              ).then((m) => m.CarDetailPageComponent),
            data: {
              config: CAR_CONFIG,
              title: '렌터카 상세',
            },
          },
        ],
      },
    ],
  },
];
